<template>
  <div class="col-xs-12 mainContent" :class="$route.meta.style">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
};
</script>
